import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applyFilters } from "actions/filterActions.js";

import H5 from "components/H5.js";

import {
  udpateGroupLabels
} from "../Helpers";
import {
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import "./RightPanel.css";

import {
  getBuyplanSummary
} from "actions/buyplanSummaryActions.js";

import { appliedFiltersSelector, isDataLoadingSelector } from "selectors/filtersSelector";

import FiltersList from "components/Filters/WhiteboardList/WhiteboardList.jsx";

function RightPanel({ buyplanId }) {
  const dispatch = useDispatch();

  const appliedFilters = useSelector(appliedFiltersSelector);
  const isDataLoading = useSelector(isDataLoadingSelector);

  const labelsChange = (event) => {
  udpateGroupLabels(event.target.id, event.target.checked);
  };

  //get buy plan item data
  useEffect(() => {
  buyplanId &&
  isDataLoading === false &&
  dispatch(getBuyplanSummary(buyplanId, appliedFilters.toJS()));
  }, [dispatch, buyplanId, appliedFilters, isDataLoading]);

  const onFilterCategoryReset = evt => {
  const categoryId = evt.currentTarget.dataset.category;

  dispatch(
  applyFilters({
  others: {
    isChecked: false,
    categoryId,
    filterId: "All"
  }
  })
  );
  };

  const onCheckboxToggle = evt => {
  const {
  checked: isChecked,
  dataset: { segmentId, divisionId, collectionId, categoryId, filterId }
  } = evt.target;

  dispatch(
  applyFilters({
  others: {
    isChecked,
    categoryId,
    filterId,
    dataset: {
    name: filterId,
    segment_id: segmentId,
    division_id: divisionId,
    collection_id: collectionId
    }
  }
  })
  );
  };

  const getDisplayValue = filterKey => {
  switch (filterKey) {
  case "genders":
  return "Gender";
  default:
  return filterKey.replace("_", " ");
  }
  };

  const applyToChange = () => {
  // var buyPlanItems = getMainBuyplanItems();
  // setCanvasBuyplanItems(buyPlanItems);
  // setSelectorBuyplanItems(buyPlanItems);
  // updateSelectionCanvasItems();
  };

  return (
  <div className="rightPanel">
  <H5 className="mb-2">Labels</H5>
  <div className="labelsOption">
  <FormGroup check>
    <Input type="checkbox" defaultChecked={true} id="product_name" onChange={labelsChange} />
    <Label check for="product_name">Product Name</Label>
  </FormGroup>
  <FormGroup check>
    <Input type="checkbox" defaultChecked={true} id="product_sku" onChange={labelsChange} />
    <Label check for="product_sku">Product SKU</Label>
  </FormGroup>
  <FormGroup check>
    <Input type="checkbox" id="product_color" onChange={labelsChange} />
    <Label check for="product_color">Display Color</Label>
  </FormGroup>
  <FormGroup check>
    <Input type="checkbox" id="product_wprice" onChange={labelsChange} />
    <Label check for="product_wprice">Wholesale Price</Label>
  </FormGroup>
  <FormGroup check>
    <Input type="checkbox" id="product_rprice" onChange={labelsChange} />
    <Label check for="product_rprice">Retail Price</Label>
  </FormGroup>
  </div>

  {/* <div className="filterTitle ftb">Filters</div> */}
  <H5 className="mt-2 mb-2">Filters</H5>
  <div className="labelsOption">
  <H5 className="mt-1 mb-1">Apply To</H5>
  <FormGroup check>
    <Input type="checkbox" defaultChecked={true} id="applyto_canvas" onChange={applyToChange} />
    <Label check for="applyto_canvas">Canvas</Label>
  </FormGroup>
  <FormGroup check>
    <Input type="checkbox" defaultChecked={true} id="applyto_selector" onChange={applyToChange} />
    <Label check for="applyto_selector">Selector</Label>
  </FormGroup>
  </div>

  <FiltersList
  getDisplayValue={getDisplayValue}
  onFilterCategoryReset={onFilterCategoryReset}
  onToggle={onCheckboxToggle}
  />
  </div>
  );
}

export default RightPanel;
